import { Grid2 } from "@mui/material";
import { ReactNode } from "react";
import { GKModalProps } from "utils/commonInterface";
import GKButton from "./GKButton";
import GKModal from "./GKModal";
import GKTypography from "./GKTypography";
import { SendNotificationIcon } from "./Icons";

interface Props {
  title: string;
  onConfirm: () => void;
  messageContent?: ReactNode;
  customButtonText?: string;
}

const ConfirmationModal = (props: Props & GKModalProps) => {
  const {
    open,
    setOpen,
    title,
    onConfirm,
    messageContent,
    customButtonText = "",
  } = props;

  const modalMessageHandler = () => {
    if (messageContent) return messageContent;
    return `Are you sure you want to ${title.toLowerCase()} this item?`;
  };

  const buttonTextHandle = () => {
    if (customButtonText) return customButtonText;
    return "Send";
  };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={title}
      footer={
        <GKButton
          variant="outlined"
          color="primary"
          onClick={() => {
            onConfirm();
            setOpen(false);
          }}
        >
          {buttonTextHandle()}
        </GKButton>
      }
    >
      <Grid2
        container
        justifyContent={"center"}
        alignItems={"center"}
        spacing={1}
      >
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <SendNotificationIcon width={26} height={26} />
        </Grid2>
        <Grid2 size={7} textAlign={"center"}>
          <GKTypography fontWeight={500} fontSize={15}>
            {modalMessageHandler()}
          </GKTypography>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};
export default ConfirmationModal;
